(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rc-before-after"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rc-before-after'))customElements.define('rc-before-after',class extends HTMLElement{
 connectedCallback(){this.controller=new AbortController();const options={signal:this.controller.signal};this.track=this.querySelector('[data-ba-track]');this.cards=[...this.querySelectorAll('[data-ba-card]')];this.navigation=this.querySelector('[data-ba-navigation]');this.previous=this.querySelector('[data-ba-direction="-1"]');this.next=this.querySelector('[data-ba-direction="1"]');this.counter=this.querySelector('[data-ba-current]');if(!this.cards.length){this.navigation.hidden=true;return}this.querySelectorAll('[data-ba-direction]').forEach(button=>button.addEventListener('click',()=>this.move(Number(button.dataset.baDirection)),options));this.track.addEventListener('scroll',()=>this.update(),{...options,passive:true});this.track.addEventListener('keydown',event=>{if(event.target!==this.track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1)}},options);document.addEventListener('shopify:block:select',event=>{const card=this.cards.find(item=>item.id==='BeforeAfterCard-'+event.detail.blockId);if(card)this.go(card)},options);this.observer=new ResizeObserver(()=>this.update());this.observer.observe(this.track);this.update()}
 position(card){return card.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft}
 update(){const max=this.track.scrollWidth-this.track.clientWidth;this.navigation.hidden=max<3;this.previous.disabled=this.track.scrollLeft<3;this.next.disabled=this.track.scrollLeft>=max-3;let nearest=0;this.cards.forEach((card,index)=>{if(Math.abs(this.position(card)-this.track.scrollLeft)<Math.abs(this.position(this.cards[nearest])-this.track.scrollLeft))nearest=index});this.index=nearest;this.counter.textContent=String(this.index+1)}
 move(direction){this.go(this.cards[Math.max(0,Math.min(this.cards.length-1,this.index+direction))])}
 go(card){if(!card)return;this.track.scrollTo({left:this.position(card),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}
 disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-catalog"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rc-catalog'))customElements.define('rc-catalog',class extends HTMLElement{
 connectedCallback(){this.controller=new AbortController();const options={signal:this.controller.signal};this.cards=[...this.querySelectorAll('[data-catalog-card]')];this.grid=this.querySelector('[data-catalog-grid]');this.input=this.querySelector('[name="q"]');this.sort=this.querySelector('[data-catalog-sort]');this.count=this.querySelector('[data-catalog-count]');this.empty=this.querySelector('[data-catalog-empty]');this.querySelector('form')?.addEventListener('submit',event=>{event.preventDefault();this.refresh(true)},options);this.input?.addEventListener('input',()=>this.refresh(false),options);this.sort?.addEventListener('change',()=>this.refresh(false),options);this.querySelector('[data-catalog-clear]').addEventListener('click',()=>{if(this.input)this.input.value='';this.refresh(true);this.input?.focus()},options);document.addEventListener('shopify:block:select',event=>{if(this.contains(event.target)){if(this.input)this.input.value='';this.refresh(false)}},options);this.refresh(false)}
 normalize(value){return value.normalize('NFD').replace(/\p{Diacritic}/gu,'').toLocaleLowerCase('nl').trim()}
 refresh(updateUrl){const query=this.normalize(this.input?.value||'');const words=query.split(/\s+/).filter(Boolean);let count=0;this.cards.forEach(card=>{card.hidden=!words.every(word=>this.normalize(card.dataset.search).includes(word));if(!card.hidden)count++});const ordered=[...this.cards].sort((a,b)=>{if(this.sort?.value==='price-ascending')return Number(a.dataset.price)-Number(b.dataset.price);if(this.sort?.value==='price-descending')return Number(b.dataset.price)-Number(a.dataset.price);if(this.sort?.value==='title-ascending')return a.dataset.title.localeCompare(b.dataset.title,'nl');return Number(a.dataset.order)-Number(b.dataset.order)});ordered.forEach(card=>this.grid.append(card));if(this.count)this.count.textContent=count===1?this.dataset.countOne:this.dataset.countTemplate.replace('__COUNT__',String(count));this.empty.hidden=count>0;if(updateUrl&&this.dataset.searchable==='true'){const url=new URL(location.href);if(query)url.searchParams.set('q',this.input.value.trim());else url.searchParams.delete('q');history.replaceState(null,'',url)}}
 disconnectedCallback(){this.controller?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-header"]) return;
  try {
    
  document.addEventListener('keydown', event => { if(event.key !== 'Escape') return; const open = document.querySelectorAll('[data-header] details[open]'); const deepest = [...open].reverse()[0]; if(deepest){deepest.open=false;deepest.querySelector('summary')?.focus();} });
  document.addEventListener('click', event => { document.querySelectorAll('[data-header] details[open]').forEach(detail => {if(!detail.contains(event.target) || event.target.closest('a')) detail.open=false;}); });
  const initAnnouncements = root => root.querySelectorAll('[data-announcement-slider]').forEach(slider => {
    if (slider.dataset.ready) return;
    slider.dataset.ready='true';
    const slides = [...slider.querySelectorAll('[data-announcement-slide]')];
    if(slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let current=0;
    const timer=setInterval(() => {
      if(!slider.isConnected){clearInterval(timer);return;}
      if(document.hidden || slider.matches(':hover') || slider.contains(document.activeElement)) return;
      slides[current].hidden=true;current=(current+1)%slides.length;slides[current].hidden=false;
    }, Number(slider.dataset.interval)||5000);
    slider.addEventListener('shopify:block:select',event => {clearInterval(timer);slides.forEach(slide=>slide.hidden=!slide.contains(event.target)&&slide!==event.target);});
  });
  initAnnouncements(document);
  document.addEventListener('shopify:section:load',event=>initAnnouncements(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-home-hero"] && !Shopify.designMode) return;
  try {
    
const homeHeadlines = new WeakMap();
function initializeHomeHeadlines(scope) {
  scope.querySelectorAll('[data-home-headline]').forEach(el => {
    if (homeHeadlines.has(el)) return;
    const words = [...el.querySelectorAll('.rc-home-hero__phrase')];
    if (words.length < 2 || el.dataset.rotate === 'false') return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const interval = Math.max(3000, Number(el.dataset.interval) || 4000);
    let index = 0;
    let timer;
    function schedule() {
      clearTimeout(timer);
      if (motion.matches || document.hidden || !el.isConnected) return;
      timer = setTimeout(() => {
        if (!el.isConnected) return destroy();
        words[index].classList.remove('is-active');
        index = (index + 1) % words.length;
        words[index].classList.add('is-active');
        schedule();
      }, interval);
    }
    function destroy() {
      clearTimeout(timer);
      controller.abort();
      homeHeadlines.delete(el);
    }
    homeHeadlines.set(el, destroy);
    motion.addEventListener('change', schedule, { signal: controller.signal });
    document.addEventListener('visibilitychange', schedule, { signal: controller.signal });
    schedule();
  });
}
initializeHomeHeadlines(document);
document.addEventListener('shopify:section:load', event => initializeHomeHeadlines(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-home-headline]').forEach(el => homeHeadlines.get(el)?.());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-home-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rc-home-review-carousel'))customElements.define('rc-home-review-carousel',class extends HTMLElement{connectedCallback(){this.controller=new AbortController();const track=this.querySelector('[data-home-review-track]');const buttons=this.querySelectorAll('[data-home-review-step]');if(!track)return;const update=()=>buttons.forEach(button=>{button.disabled=Number(button.dataset.homeReviewStep)<0?track.scrollLeft<2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2;});buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.homeReviewStep)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}),{signal:this.controller.signal}));track.addEventListener('scroll',update,{passive:true,signal:this.controller.signal});window.addEventListener('resize',update,{signal:this.controller.signal});document.addEventListener('shopify:block:select',event=>{if(this.contains(event.target))event.target.scrollIntoView({behavior:'instant',block:'nearest',inline:'nearest'});},{signal:this.controller.signal});update();}disconnectedCallback(){this.controller?.abort();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rc-review-list'))customElements.define('rc-review-list',class extends HTMLElement{
 connectedCallback(){
  this.controller=new AbortController();
  const signal=this.controller.signal;
  this.querySelectorAll('[data-rating-filter]').forEach(button=>button.addEventListener('click',()=>{
   const rating=button.dataset.ratingFilter;
   let visible=0;
   this.querySelectorAll('[data-rating]').forEach(review=>{review.hidden=rating!=='all'&&review.dataset.rating!==rating;if(!review.hidden)visible++});
   this.querySelectorAll('[data-rating-filter]').forEach(filter=>filter.setAttribute('aria-pressed',String(filter===button)));
   const reset=this.querySelector('[data-rating-filter="all"]');if(reset)reset.hidden=rating==='all';
   const empty=this.querySelector('[data-reviews-empty]');if(empty)empty.hidden=visible>0;
  },{signal}));
  this.querySelector('[data-review-sort]')?.addEventListener('change',event=>{
   const mode=event.target.value;
   const reviews=Array.from(this.querySelectorAll('[data-rating]'));
   reviews.sort((a,b)=>mode==='highest'?Number(b.dataset.rating)-Number(a.dataset.rating):mode==='lowest'?Number(a.dataset.rating)-Number(b.dataset.rating):Number(a.dataset.reviewIndex)-Number(b.dataset.reviewIndex));
   const list=this.querySelector('.rc-reviews__list');reviews.forEach(review=>list.append(review));
  },{signal});
  document.addEventListener('shopify:block:select',event=>{if(this.contains(event.target))this.querySelector('[data-rating-filter="all"]')?.click()},{signal});
 }
 disconnectedCallback(){this.controller?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-technology"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('click', event => {
   const button = event.target.closest('[data-study-open]');
   if (button) {
     const dialog = document.getElementById(button.dataset.studyOpen);
     if (!dialog || dialog.open) return;
     dialog.addEventListener('close', () => {
       if (button.isConnected) button.focus({ preventScroll: true });
     }, { once: true });
     dialog.showModal();
   } else if (event.target.matches('dialog.rc-study')) {
     const dialog = event.target;
     const rect = dialog.getBoundingClientRect();
     if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
   }
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-testimonials"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rc-testimonials'))customElements.define('rc-testimonials',class extends HTMLElement{
 connectedCallback(){this.controller=new AbortController();const signal=this.controller.signal;this.track=this.querySelector('.rc-stories__track');this.cards=[...this.querySelectorAll('.rc-stories__card')];this.dots=[...this.querySelectorAll('.rc-stories__dot')];if(!this.cards.length)return;this.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>this.go(this.index+Number(b.dataset.direction)),{signal}));this.dots.forEach(b=>b.addEventListener('click',()=>this.go(Number(b.dataset.index)),{signal}));this.track.addEventListener('scroll',()=>this.update(),{passive:true,signal});document.addEventListener('shopify:block:select',e=>{const i=this.cards.findIndex(c=>c.id==='Story-'+e.detail.blockId);if(i>=0)this.go(i)},{signal});this.observer=new ResizeObserver(()=>this.update());this.observer.observe(this.track);this.update()}
 update(){const stride=this.cards[0].getBoundingClientRect().width+20;this.max=Math.max(0,this.cards.length-Math.round((this.track.clientWidth+20)/stride));this.index=Math.min(this.max,Math.max(0,Math.round(this.track.scrollLeft/stride)));this.dots.forEach((d,i)=>{d.hidden=i>this.max;d.setAttribute('aria-current',String(i===this.index))});this.querySelectorAll('[data-direction]').forEach(b=>b.disabled=Number(b.dataset.direction)<0?this.index===0:this.index>=this.max)}
 go(i){this.track.scrollTo({left:Math.max(0,Math.min(this.max,i))*(this.cards[0].getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}
 disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-video-feature"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rc-feature-video'))customElements.define('rc-feature-video',class extends HTMLElement{
 connectedCallback(){
  this.video=this.querySelector('video');
  if(!this.video){this.querySelector('button').hidden=true;return}
  this.controller=new AbortController();this.visible=false;this.manualRequested=false;this.waitingForHelper=false;this.motion=matchMedia('(prefers-reduced-motion: reduce)');
  const signal=this.controller.signal;
  this.querySelector('button').addEventListener('click',()=>this.play(true),{signal});
  this.video.addEventListener('play',()=>this.classList.add('is-playing'),{signal});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)this.video.pause();else if(this.visible)this.play()},{signal});
  this.motion.addEventListener('change',()=>{if(this.motion.matches&&!this.manualRequested)this.video.pause();else if(this.visible)this.play()},{signal});
  this.observer=new IntersectionObserver(entries=>entries.forEach(e=>{
   this.visible=e.isIntersecting&&e.intersectionRatio>=.45;
   if(this.visible){if(this.dataset.autoplay==='true')this.play()}else{this.manualRequested=false;this.video.pause()}
  }),{threshold:[0,.45]});this.observer.observe(this);
 }
 play(manual=false){
  if(manual)this.manualRequested=true;
  if(!this.isConnected||document.hidden||(!this.manualRequested&&!this.visible))return;
  if(!this.manualRequested&&this.dataset.autoplay!=='true')return;
  if(!this.manualRequested&&(this.motion.matches||navigator.connection?.saveData))return;
  if(window.RCLazyVideo){
   window.RCLazyVideo.play(this.video).then(()=>{if(!this.isConnected||document.hidden||(!this.manualRequested&&(!this.visible||this.motion.matches)))this.video.pause()}).catch(()=>this.classList.remove('is-playing'));
  }else if(!this.waitingForHelper){
   this.waitingForHelper=true;
   document.addEventListener('rc:video-ready',()=>{this.waitingForHelper=false;this.play()},{once:true,signal:this.controller.signal});
  }
 }
 disconnectedCallback(){this.manualRequested=false;this.visible=false;this.video?.pause();this.controller?.abort();this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();
})();
